const recordDetailsConfig = {
    keyOrders: {
        audits: ['auditId', 'correlationId', 'status', 'dateCreated', 'lastUpdated', 'lastModifiedBy'],
        flaggedMetadata: [
            {
                formatter: 'amsProgramTitle',
                key: 'amsPrograms.title',
                label: 'Title',
            },
            'status',
            {
                key: 'lastUpdated',
                label: 'Flag Last Updated',
            },
            {
                formatter: 'amsProgramLastUpdateDetail',
                key: 'amsPrograms.lastUpdate',
                label: 'AMS Last Updated',
            },
            {
                formatter: 'amsProgramEchostarId',
                key: 'amsPrograms.echostarId',
                label: 'Echostar Id',
            },
            'roviProgramId',
            {
                formatter: 'shellEchostarId',
                key: 'shellEchostarIds',
                label: 'Shell Echostar Id',
            },
            'sourceId',
            'ingestSource',
        ],
        massActionResults: ['correlationId', 'command', 'status', 'dateCreated', 'lastUpdated', 'lastModifiedBy'],
        mediaItems: [
            'title',
            'showName',
            'episodeName',
            {
                key: 'amsFranchise.eidrId',
                label: 'EIDR ID',
            },
            {
                key: 'alid',
                label: 'ALID',
            },
            {
                key: 'amsFranchise.tvRating',
                label: 'TV Rating',
            },
            {
                key: 'amsFranchise.movieRating',
                label: 'Movie Rating',
            },
            {
                key: 'amsFranchise.category',
                label: 'Category',
            },
            {
                key: 'amsFranchise.sportsSubtitle',
                label: 'Sports Subtitle',
            },
            {
                key: 'amsFranchise.showType',
                label: 'Show Type',
            },
            'description',
            'originalAirDate',
            'seasonNumber',
            'episodeNumber',
            'releaseYear',
            'duration',
            'rating',
            {
                key: 'externalNetwork.provider.name',
                label: 'Provider',
            },
            {
                key: 'externalNetwork.network.name',
                label: 'Network',
            },
            'genres',
            'idFromPartner',
            'categories',
            'offerings',
            'encodedMedia',
            'expression',
            'active',
            'matureContent',
            'subscriptionRequired',
            'closedCaptioning',
            'state',
            'priority',
            'fullyFranchiseMapped',
            'displayPaths',
            'service',
            'guid',
            'externalGuid',
            'dateCreated',
            'createdBy',
            'lastUpdated',
            'lastModifiedBy',
            'version',
            'mediaItemId',
            'amsEpisode',
            'amsFranchise',
            'daiProviderId',
            'adSlots',
            'daiEffectiveDate',
            'drm.offlineDuration',
            'externalNetwork',
            'drm',
            'publishDate',
            'sourcePath',
            'pushVod',
            'correlationId',
            'sortablePriority',
            'sourceId',
            'ingestSource',
        ],
        moviesAndPrograms: [
            'title',
            'showName',
            'episodeName',
            'description',
            'originalAirDate',
            'seasonNumber',
            'episodeNumber',
            'releaseYear',
            'duration',
            'rating',
            'sourceId',
            'ingestSource',
            {
                key: 'tmsId',
                label: 'TMS ID',
            },
            {
                key: 'eidrId',
                label: 'EIDR ID',
            },
            {
                key: 'externalNetwork.provider.name',
                label: 'Provider',
            },
            {
                key: 'externalNetwork.network.name',
                label: 'Network',
            },
            {
                key: 'tvRating',
                label: 'TV Rating',
            },
            {
                key: 'movieRating',
                label: 'Movie Rating',
            },
            {
                key: 'category',
                label: 'Category',
            },
            {
                key: 'sportsSubtitle',
                label: 'Sports Subtitle',
            },
            {
                key: 'showType',
                label: 'Show Type',
            },
            'genres',
            'idFromPartner',
            'categories',
            'offerings',
            'encodedMedia',
            'expression',
            'active',
            'matureContent',
            'subscriptionRequired',
            'closedCaptioning',
            'state',
            'priority',
            'fullyFranchiseMapped',
            'displayPaths',
            'service',
            'guid',
            'externalGuid',
            'dateCreated',
            'createdBy',
            'lastUpdated',
            'lastModifiedBy',
            'version',
            'mediaItemId',
            'amsEpisode',
            'amsFranchise',
            'daiProviderId',
            'adSlots',
            'daiEffectiveDate',
            'drm.offlineDuration',
            'externalNetwork',
            'drm',
            'publishDate',
            'sourcePath',
            'pushVod',
            'correlationId',
            'sortablePriority',
        ],
        networks: [
            'name',
            'alternateName',
            'networkId',
            'guid',
            'dateCreated',
            'lastUpdated',
            'description',
            'version',
            'allowed',
            'fastPath',
            'mrmTestId',
            'mrmProdId',
            'adDecisioningSystem',
            'freewheelNetworkName',
        ],
        providers: [
            'name',
            'partnerId',
            'playerType',
            'guid',
            'dateCreated',
            'createdBy',
            'lastUpdated',
            'lastModifiedBy',
        ],
        violations: [
            'violationId',
            'correlationId',
            'category',
            'statusCode',
            'rule',
            'reason',
            'dateCreated',
            'lastUpdated',
            'lastModifiedBy',
        ],
    },
    keyTypes: {
        'amsPrograms.lastUpdate': {
            type: 'datetime',
        },
        daiEffectiveDate: {
            type: 'date',
        },
        dateCreated: {
            type: 'datetime',
        },
        duration: {
            type: 'duration',
        },
        echostarContentType: {
            type: 'contentType',
        },
        endDate: {
            type: 'datetime',
        },
        lastMappingTime: {
            type: 'datetime',
        },
        lastNamesingleNameorgName: {
            label: 'Last Name/Single Name/Org Name',
        },
        lastUpdate: {
            type: 'datetime',
        },
        lastUpdated: {
            type: 'datetime',
        },
        originalAirDate: {
            type: 'date',
            format: 'L',
        },
        publishDate: {
            type: 'date',
        },
        runtime: {
            type: 'duration',
        },
        startDate: {
            type: 'datetime',
        },
        streetDate: {
            type: 'date',
        },
    },
};

export default recordDetailsConfig;
